import { gql } from "graphql-tag";

import { documentLink, externalLink } from "~/app/prismic/prismic-fragments";

export const getButtonGalleryV2 = pageType => gql`
  fragment ${pageType}_Button_gallery_v2 on ${pageType}BodyButton_gallery_v2 {
    type
    label
    variation {
      ... on ${pageType}BodyButton_gallery_v2Default {
        items {
          button_label
          button_link {
            ...documentLink
            ...externalLink
          }
          button_color
        }
      }
    }
  }
  ${documentLink}
  ${externalLink}
`;
